import React, { useState } from 'react';

import '../style.css';

import { useCallback } from 'react';

// import { Razorpay as RazorpayCheckout } from 'razorpay-checkout';

const Razorpay = ({ children, createPayment, onPaymentSuccess, onPaymentFailed, paymentGateways }) => {

    console.log("👉 Razorpay Component Rendered");

    const onPaymentFailure = useCallback((response) => {
        console.log("❌ Payment Failed Callback Triggered:", response);

        onPaymentFailed({
            'reason': response?.error?.description ?? 'Payment Failed. Please try again.'
        });
    }, [onPaymentFailed]);

    const [isLoading, setIsLoading] = useState(false);

    const payNow = useCallback(async () => {

        console.log("👉 Pay Now Clicked");

        try {
            setIsLoading(true);

            console.log("⏳ Calling createPayment API...");
            let orderResponse = await createPayment();

            console.log("✅ createPayment Response:", orderResponse);

            setIsLoading(false);

            if (orderResponse?.order) {

                console.log("📦 Order Object Found:", orderResponse.order);

                if (orderResponse?.order?.order_error_message) {
                    console.log("❌ Order Error Message:", orderResponse.order.order_error_message);

                    onPaymentFailed({
                        'reason': orderResponse?.order?.order_error_message
                    });

                } else {

                    const options = {
                        key: orderResponse?.keyId,
                        amount: orderResponse?.amountInPaise,
                        currency:
                            orderResponse?.order?.currencyCode ||
                            orderResponse?.order?.currency_code ||
                            'INR',
                        order_id: orderResponse?.order?.razorpayOrderId,
                        handler: (response) => {
                            console.log("✅ Payment Success:", response);

                            onPaymentSuccess(
                                orderResponse?.order?.id,
                                response
                            );
                        }
                    };

                    console.log("🧾 Razorpay Options:", options);

                    // ✅ SAFETY CHECKS
                    if (!window.Razorpay) {
                        console.log("❌ Razorpay SDK not loaded");
                        throw new Error("Razorpay SDK failed to load");
                    }

                    if (!options.order_id) {
                        console.log("❌ Missing Razorpay Order ID");
                        throw new Error("Order ID missing");
                    }

                    const rzr = new window.Razorpay(options);
                    console.log("Razorpay", window.Razorpay);

                    rzr.on('payment.failed', (errResponse) => {
                        console.log("❌ Razorpay payment.failed triggered:", errResponse);
                        onPaymentFailure(errResponse);
                    });

                    console.log("📤 Opening Razorpay Popup...");
                    rzr.open();
                    
   
                }

            } else {
                console.log("❌ No order found in response");
                throw new Error('Something went wrong. Please try again.');
            }

        } catch (e) {
            console.log("❌ Exception in payNow:", e);

            onPaymentFailed({
                'reason': e.message
            });
        }

    }, [createPayment, onPaymentFailed, onPaymentFailure, onPaymentSuccess]);

    let button = <button className="razarpayButton payNowButton" >{paymentGateways?.length > 1 ? "Pay Using Razorpay" : "Pay Now"}</button>

    if (children) {
        button = children;
    }

    if (isLoading) {
        console.log("⏳ Loading state active");
        button = <img src={require('../images/loader.gif')} width={40} alt="loading" />
    }
    console.log("Razorpay*", window.Razorpay === window.RazorpayCheckout);

    return (
        <div className="payNowButtonContainer" onClick={e => payNow()}>
            {console.log("🧩 Rendering Button")}
            {button}
        </div>
    )
}

export default Razorpay;
